import { Action } from 'redux';

import { CreateFlowSubscription } from '../../app/actions/AppActionTypes';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';
import { ISpaceItemDetailInfo } from '../../ts/models/ISpaceItemDetailInfo';

export interface CreateFlowSubscriptionReduxAction extends Action {
  readonly flow: IContentInfo;
}

export function createFlowSubscription(flow: IContentInfo | ISpaceItemDetailInfo<'flow'>): CreateFlowSubscriptionReduxAction {
  return {
    type: CreateFlowSubscription,
    flow
  };
}
